import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import ReactDOM from 'react-dom';
import { Container, Icon } from '../../..';
import useOnClickOutside from '../../../shared/hooks/useOnClickOutside';
import { IconName } from '../../Atoms/Icon/Icon.enum';
import BasePopupContainer from './BaseComponents/BasePopupContainer';
import BasePopupOverlay from './BaseComponents/BasePopupOverlay';
const Popup = forwardRef(({ open = false, title, triggerEl, closeEl, enableScroll, large, onClose, overlayDismiss, children, fullScreen, padding, hasTitleDivider = true, isNewDesign = false, maxWidth, }, ref) => {
    const popupContentContainerRef = useRef(null);
    const [isPopupOpen, setIsPopupOpen] = useState(open);
    const [isBrowser, setIsBrowser] = useState(false);
    useEffect(() => {
        setIsBrowser(true);
    }, []);
    useEffect(() => {
        if (isPopupOpen && !enableScroll) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isPopupOpen, enableScroll]);
    const openPopup = () => {
        setIsPopupOpen(true);
    };
    const closePopup = (dismiss = false) => {
        setIsPopupOpen(false);
        if (dismiss || !onClose)
            return;
        onClose();
    };
    const clickOutsideHandler = () => {
        overlayDismiss && closePopup(true);
    };
    useOnClickOutside(popupContentContainerRef, clickOutsideHandler);
    const createPopupTrigger = (trigger) => React.cloneElement(trigger, {
        onClick: () => openPopup(),
        role: 'button',
        'data-testid': 'trigger-button',
    });
    const getPopupWrapper = () => {
        let wrapper = document.getElementById('popup-wrapper');
        if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.setAttribute('id', 'popup-wrapper');
            wrapper.setAttribute('data-testid', 'popup-wrapper');
            document.body.appendChild(wrapper);
        }
        return wrapper;
    };
    const getModalContent = () => isPopupOpen ? (_jsx(BasePopupOverlay, Object.assign({ "data-testid": "popup", isNewDesign: isNewDesign, role: "dialog" }, { children: _jsxs(BasePopupContainer, Object.assign({ ref: popupContentContainerRef, fullScreen: fullScreen, isNewDesign: isNewDesign, large: large, maxWidth: maxWidth, padding: padding }, { children: [_jsxs(Container, Object.assign({ className: "popup-header", noPadding: true }, { children: [title, closeEl ? (React.cloneElement(closeEl, { onClick: () => closePopup(true) })) : (_jsx("button", Object.assign({ "data-testid": "popup-close-button", onClick: () => closePopup(true), type: "button" }, { children: isNewDesign ? (_jsx(Icon, { name: IconName.CLOSE, strokeWidth: 1.5 }, void 0)) : (_jsx(Icon, { name: IconName.CLOSE_BORDER }, void 0)) }), void 0))] }), void 0), hasTitleDivider ? _jsx("hr", { className: "popup-divider" }, void 0) : null, _jsx(Container, Object.assign({ className: "popup-content", noPadding: true }, { children: children }), void 0)] }), void 0) }), void 0)) : null;
    useImperativeHandle(ref, () => ({
        close: (dismiss = false) => closePopup(dismiss),
        open: () => openPopup(),
    }));
    return (_jsxs(_Fragment, { children: [triggerEl && createPopupTrigger(triggerEl), isBrowser && ReactDOM.createPortal(getModalContent(), getPopupWrapper())] }, void 0));
});
export default Popup;
//# sourceMappingURL=Popup.js.map